// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file child_organization_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { ProfileProfileLock } from "./locks_pb";
import { file_locks } from "./locks_pb";
import type { ProfileData } from "./profile_pb";
import { file_profile } from "./profile_pb";
import type { SyncUpdate, SyncUpdateProfile } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import { file_vault_service } from "./vault_service_pb";
import { file_license_type } from "./license_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file child_organization_service.proto.
 */
export const file_child_organization_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_locks, file_profile, file_sync_update, file_vault_service, file_license_type]);

/**
 * @generated from message domain.ListChildOrganizationsRequest
 */
export type ListChildOrganizationsRequest = Message<"domain.ListChildOrganizationsRequest"> & {
  /**
   * @generated from field: string parent_organization_id = 1;
   */
  parentOrganizationId: string;

  /**
   * @generated from field: bool force_list_all = 2;
   */
  forceListAll: boolean;
};

/**
 * Describes the message domain.ListChildOrganizationsRequest.
 * Use `create(ListChildOrganizationsRequestSchema)` to create a new message.
 */
export const ListChildOrganizationsRequestSchema: GenMessage<ListChildOrganizationsRequest> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 0);

/**
 * @generated from message domain.ListChildOrganizationsResponse
 */
export type ListChildOrganizationsResponse = Message<"domain.ListChildOrganizationsResponse"> & {
  /**
   * @generated from field: repeated domain.ListChildOrganizationsResponse.ChildOrganization child_organizations = 1;
   */
  childOrganizations: ListChildOrganizationsResponse_ChildOrganization[];

  /**
   * @generated from field: int32 delegated_admin_count_limit = 2;
   */
  delegatedAdminCountLimit: number;
};

/**
 * Describes the message domain.ListChildOrganizationsResponse.
 * Use `create(ListChildOrganizationsResponseSchema)` to create a new message.
 */
export const ListChildOrganizationsResponseSchema: GenMessage<ListChildOrganizationsResponse> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 1);

/**
 * @generated from message domain.ListChildOrganizationsResponse.ChildOrganization
 */
export type ListChildOrganizationsResponse_ChildOrganization = Message<"domain.ListChildOrganizationsResponse.ChildOrganization"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated domain.ListChildOrganizationsResponse.ChildOrganization.User users = 4;
   */
  users: ListChildOrganizationsResponse_ChildOrganization_User[];

  /**
   * @generated from field: repeated domain.ListChildOrganizationsResponse.ChildOrganization.DelegatedAdmin delegated_admins = 5;
   */
  delegatedAdmins: ListChildOrganizationsResponse_ChildOrganization_DelegatedAdmin[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: string parent_organization_metadata = 7;
   */
  parentOrganizationMetadata: string;

  /**
   * only set if user is admin in the parent organization
   *
   * @generated from field: domain.SyncUpdateProfile admin_profile = 8;
   */
  adminProfile?: SyncUpdateProfile | undefined;

  /**
   * @generated from oneof domain.ListChildOrganizationsResponse.ChildOrganization.license
   */
  license: {
    /**
     * @generated from field: domain.ListChildOrganizationsResponse.ChildOrganization.LicenseNone none = 9;
     */
    value: ListChildOrganizationsResponse_ChildOrganization_LicenseNone;
    case: "none";
  } | {
    /**
     * @generated from field: domain.ListChildOrganizationsResponse.ChildOrganization.LicenseViaMsp via_msp = 10;
     */
    value: ListChildOrganizationsResponse_ChildOrganization_LicenseViaMsp;
    case: "viaMsp";
  } | {
    /**
     * @generated from field: domain.ListChildOrganizationsResponse.ChildOrganization.LicenseExample example = 11;
     */
    value: ListChildOrganizationsResponse_ChildOrganization_LicenseExample;
    case: "example";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message domain.ListChildOrganizationsResponse.ChildOrganization.
 * Use `create(ListChildOrganizationsResponse_ChildOrganizationSchema)` to create a new message.
 */
export const ListChildOrganizationsResponse_ChildOrganizationSchema: GenMessage<ListChildOrganizationsResponse_ChildOrganization> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 1, 0);

/**
 * @generated from message domain.ListChildOrganizationsResponse.ChildOrganization.User
 */
export type ListChildOrganizationsResponse_ChildOrganization_User = Message<"domain.ListChildOrganizationsResponse.ChildOrganization.User"> & {
  /**
   * @generated from field: bool is_admin = 1;
   */
  isAdmin: boolean;

  /**
   * @generated from field: bool is_not_connected = 2;
   */
  isNotConnected: boolean;

  /**
   * @generated from field: bool has_start_code = 3;
   */
  hasStartCode: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp last_active_at = 4;
   */
  lastActiveAt?: Timestamp | undefined;
};

/**
 * Describes the message domain.ListChildOrganizationsResponse.ChildOrganization.User.
 * Use `create(ListChildOrganizationsResponse_ChildOrganization_UserSchema)` to create a new message.
 */
export const ListChildOrganizationsResponse_ChildOrganization_UserSchema: GenMessage<ListChildOrganizationsResponse_ChildOrganization_User> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 1, 0, 0);

/**
 * @generated from message domain.ListChildOrganizationsResponse.ChildOrganization.DelegatedAdmin
 */
export type ListChildOrganizationsResponse_ChildOrganization_DelegatedAdmin = Message<"domain.ListChildOrganizationsResponse.ChildOrganization.DelegatedAdmin"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * @generated from field: string parent_organization_profile_id = 2;
   */
  parentOrganizationProfileId: string;

  /**
   * @generated from field: string personal_vault_id = 3;
   */
  personalVaultId: string;
};

/**
 * Describes the message domain.ListChildOrganizationsResponse.ChildOrganization.DelegatedAdmin.
 * Use `create(ListChildOrganizationsResponse_ChildOrganization_DelegatedAdminSchema)` to create a new message.
 */
export const ListChildOrganizationsResponse_ChildOrganization_DelegatedAdminSchema: GenMessage<ListChildOrganizationsResponse_ChildOrganization_DelegatedAdmin> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 1, 0, 1);

/**
 * @generated from message domain.ListChildOrganizationsResponse.ChildOrganization.LicenseViaMsp
 */
export type ListChildOrganizationsResponse_ChildOrganization_LicenseViaMsp = Message<"domain.ListChildOrganizationsResponse.ChildOrganization.LicenseViaMsp"> & {
  /**
   * @generated from field: google.protobuf.Timestamp contract_start_date = 1;
   */
  contractStartDate?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp contract_end_date = 2;
   */
  contractEndDate?: Timestamp | undefined;

  /**
   * @generated from field: int32 license_count = 3;
   */
  licenseCount: number;
};

/**
 * Describes the message domain.ListChildOrganizationsResponse.ChildOrganization.LicenseViaMsp.
 * Use `create(ListChildOrganizationsResponse_ChildOrganization_LicenseViaMspSchema)` to create a new message.
 */
export const ListChildOrganizationsResponse_ChildOrganization_LicenseViaMspSchema: GenMessage<ListChildOrganizationsResponse_ChildOrganization_LicenseViaMsp> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 1, 0, 2);

/**
 * @generated from message domain.ListChildOrganizationsResponse.ChildOrganization.LicenseNone
 */
export type ListChildOrganizationsResponse_ChildOrganization_LicenseNone = Message<"domain.ListChildOrganizationsResponse.ChildOrganization.LicenseNone"> & {
  /**
   * @generated from field: google.protobuf.Timestamp trial_end_date = 1;
   */
  trialEndDate?: Timestamp | undefined;
};

/**
 * Describes the message domain.ListChildOrganizationsResponse.ChildOrganization.LicenseNone.
 * Use `create(ListChildOrganizationsResponse_ChildOrganization_LicenseNoneSchema)` to create a new message.
 */
export const ListChildOrganizationsResponse_ChildOrganization_LicenseNoneSchema: GenMessage<ListChildOrganizationsResponse_ChildOrganization_LicenseNone> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 1, 0, 3);

/**
 * empty
 *
 * @generated from message domain.ListChildOrganizationsResponse.ChildOrganization.LicenseExample
 */
export type ListChildOrganizationsResponse_ChildOrganization_LicenseExample = Message<"domain.ListChildOrganizationsResponse.ChildOrganization.LicenseExample"> & {
};

/**
 * Describes the message domain.ListChildOrganizationsResponse.ChildOrganization.LicenseExample.
 * Use `create(ListChildOrganizationsResponse_ChildOrganization_LicenseExampleSchema)` to create a new message.
 */
export const ListChildOrganizationsResponse_ChildOrganization_LicenseExampleSchema: GenMessage<ListChildOrganizationsResponse_ChildOrganization_LicenseExample> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 1, 0, 4);

/**
 * @generated from message domain.AddDelegatedAdminRequest
 */
export type AddDelegatedAdminRequest = Message<"domain.AddDelegatedAdminRequest"> & {
  /**
   * @generated from field: string child_organization_id = 1;
   */
  childOrganizationId: string;

  /**
   * This is used only to determine the proper user to assign the new profile
   *
   * @generated from field: string parent_organization_profile_id = 2;
   */
  parentOrganizationProfileId: string;

  /**
   * @generated from field: domain.ProfileData profile = 3;
   */
  profile?: ProfileData | undefined;

  /**
   * @generated from field: domain.ProfileProfileLock admin_profile_lock = 5;
   */
  adminProfileLock?: ProfileProfileLock | undefined;
};

/**
 * Describes the message domain.AddDelegatedAdminRequest.
 * Use `create(AddDelegatedAdminRequestSchema)` to create a new message.
 */
export const AddDelegatedAdminRequestSchema: GenMessage<AddDelegatedAdminRequest> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 2);

/**
 * @generated from message domain.AddDelegatedAdminResponse
 */
export type AddDelegatedAdminResponse = Message<"domain.AddDelegatedAdminResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId: string;
};

/**
 * Describes the message domain.AddDelegatedAdminResponse.
 * Use `create(AddDelegatedAdminResponseSchema)` to create a new message.
 */
export const AddDelegatedAdminResponseSchema: GenMessage<AddDelegatedAdminResponse> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 3);

/**
 * @generated from message domain.RemoveDelegatedAdminRequest
 */
export type RemoveDelegatedAdminRequest = Message<"domain.RemoveDelegatedAdminRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId: string;
};

/**
 * Describes the message domain.RemoveDelegatedAdminRequest.
 * Use `create(RemoveDelegatedAdminRequestSchema)` to create a new message.
 */
export const RemoveDelegatedAdminRequestSchema: GenMessage<RemoveDelegatedAdminRequest> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 4);

/**
 * empty
 *
 * @generated from message domain.RemoveDelegatedAdminResponse
 */
export type RemoveDelegatedAdminResponse = Message<"domain.RemoveDelegatedAdminResponse"> & {
};

/**
 * Describes the message domain.RemoveDelegatedAdminResponse.
 * Use `create(RemoveDelegatedAdminResponseSchema)` to create a new message.
 */
export const RemoveDelegatedAdminResponseSchema: GenMessage<RemoveDelegatedAdminResponse> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 5);

/**
 * @generated from message domain.UpdateChildOrganizationRequest
 */
export type UpdateChildOrganizationRequest = Message<"domain.UpdateChildOrganizationRequest"> & {
  /**
   * @generated from field: string child_organization_id = 1;
   */
  childOrganizationId: string;

  /**
   * no change if null
   *
   * @generated from field: google.protobuf.StringValue parent_organization_metadata = 9;
   */
  parentOrganizationMetadata?: string | undefined;

  /**
   * @generated from field: domain.UpdateChildOrganizationRequest.LicenseUpdate license = 2;
   */
  license?: UpdateChildOrganizationRequest_LicenseUpdate | undefined;
};

/**
 * Describes the message domain.UpdateChildOrganizationRequest.
 * Use `create(UpdateChildOrganizationRequestSchema)` to create a new message.
 */
export const UpdateChildOrganizationRequestSchema: GenMessage<UpdateChildOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 6);

/**
 * @generated from message domain.UpdateChildOrganizationRequest.LicenseUpdate
 */
export type UpdateChildOrganizationRequest_LicenseUpdate = Message<"domain.UpdateChildOrganizationRequest.LicenseUpdate"> & {
  /**
   * @generated from oneof domain.UpdateChildOrganizationRequest.LicenseUpdate.type
   */
  type: {
    /**
     * @generated from field: domain.UpdateChildOrganizationRequest.LicenseUpdate.Trial trial = 1;
     */
    value: UpdateChildOrganizationRequest_LicenseUpdate_Trial;
    case: "trial";
  } | {
    /**
     * @generated from field: domain.UpdateChildOrganizationRequest.LicenseUpdate.ViaMsp via_msp = 2;
     */
    value: UpdateChildOrganizationRequest_LicenseUpdate_ViaMsp;
    case: "viaMsp";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message domain.UpdateChildOrganizationRequest.LicenseUpdate.
 * Use `create(UpdateChildOrganizationRequest_LicenseUpdateSchema)` to create a new message.
 */
export const UpdateChildOrganizationRequest_LicenseUpdateSchema: GenMessage<UpdateChildOrganizationRequest_LicenseUpdate> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 6, 0);

/**
 * @generated from message domain.UpdateChildOrganizationRequest.LicenseUpdate.Trial
 */
export type UpdateChildOrganizationRequest_LicenseUpdate_Trial = Message<"domain.UpdateChildOrganizationRequest.LicenseUpdate.Trial"> & {
  /**
   * @generated from field: bool extend = 1;
   */
  extend: boolean;
};

/**
 * Describes the message domain.UpdateChildOrganizationRequest.LicenseUpdate.Trial.
 * Use `create(UpdateChildOrganizationRequest_LicenseUpdate_TrialSchema)` to create a new message.
 */
export const UpdateChildOrganizationRequest_LicenseUpdate_TrialSchema: GenMessage<UpdateChildOrganizationRequest_LicenseUpdate_Trial> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 6, 0, 0);

/**
 * @generated from message domain.UpdateChildOrganizationRequest.LicenseUpdate.ViaMsp
 */
export type UpdateChildOrganizationRequest_LicenseUpdate_ViaMsp = Message<"domain.UpdateChildOrganizationRequest.LicenseUpdate.ViaMsp"> & {
  /**
   * @generated from field: int32 license_count = 1;
   */
  licenseCount: number;
};

/**
 * Describes the message domain.UpdateChildOrganizationRequest.LicenseUpdate.ViaMsp.
 * Use `create(UpdateChildOrganizationRequest_LicenseUpdate_ViaMspSchema)` to create a new message.
 */
export const UpdateChildOrganizationRequest_LicenseUpdate_ViaMspSchema: GenMessage<UpdateChildOrganizationRequest_LicenseUpdate_ViaMsp> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 6, 0, 1);

/**
 * @generated from message domain.UpdateChildOrganizationResponse
 */
export type UpdateChildOrganizationResponse = Message<"domain.UpdateChildOrganizationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.UpdateChildOrganizationResponse.
 * Use `create(UpdateChildOrganizationResponseSchema)` to create a new message.
 */
export const UpdateChildOrganizationResponseSchema: GenMessage<UpdateChildOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 7);

/**
 * @generated from message domain.ConvertChildOrganizationToIndependentRequest
 */
export type ConvertChildOrganizationToIndependentRequest = Message<"domain.ConvertChildOrganizationToIndependentRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.ConvertChildOrganizationToIndependentRequest.
 * Use `create(ConvertChildOrganizationToIndependentRequestSchema)` to create a new message.
 */
export const ConvertChildOrganizationToIndependentRequestSchema: GenMessage<ConvertChildOrganizationToIndependentRequest> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 8);

/**
 * empty
 *
 * @generated from message domain.ConvertChildOrganizationToIndependentResponse
 */
export type ConvertChildOrganizationToIndependentResponse = Message<"domain.ConvertChildOrganizationToIndependentResponse"> & {
};

/**
 * Describes the message domain.ConvertChildOrganizationToIndependentResponse.
 * Use `create(ConvertChildOrganizationToIndependentResponseSchema)` to create a new message.
 */
export const ConvertChildOrganizationToIndependentResponseSchema: GenMessage<ConvertChildOrganizationToIndependentResponse> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 9);

/**
 * @generated from message domain.AdoptChildOrganizationRequest
 */
export type AdoptChildOrganizationRequest = Message<"domain.AdoptChildOrganizationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string parent_organization_id = 2;
   */
  parentOrganizationId: string;

  /**
   * @generated from field: domain.ProfileProfileLock admin_profile_lock = 3;
   */
  adminProfileLock?: ProfileProfileLock | undefined;
};

/**
 * Describes the message domain.AdoptChildOrganizationRequest.
 * Use `create(AdoptChildOrganizationRequestSchema)` to create a new message.
 */
export const AdoptChildOrganizationRequestSchema: GenMessage<AdoptChildOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 10);

/**
 * @generated from message domain.AdoptChildOrganizationResponse
 */
export type AdoptChildOrganizationResponse = Message<"domain.AdoptChildOrganizationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.AdoptChildOrganizationResponse.
 * Use `create(AdoptChildOrganizationResponseSchema)` to create a new message.
 */
export const AdoptChildOrganizationResponseSchema: GenMessage<AdoptChildOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_child_organization_service, 11);

/**
 * @generated from service domain.ChildOrganizationService
 */
export const ChildOrganizationService: GenService<{
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400): not member of the given parent organization
   * - OrganizationInsufficientAccess (60100): not permitted to see child organization management
   * - Internal (10500)
   *
   * @generated from rpc domain.ChildOrganizationService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListChildOrganizationsRequestSchema;
    output: typeof ListChildOrganizationsResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): not logged in
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - ProfileNotFound (70400): profile in parent organization not found
   * - UserNotFound (20400): profile in parent organization is free
   * - UserAlreadyInOrganization(60401)
   * - EmailTaken(20100): A disconnected profile with the same email already exists in the child organization
   * - OrganizationNotFound (60400): not member of the parent or child organization or organization is no child organization
   * - OrganizationInsufficientAccess (60100): not admin of the child organization
   * - BadRequest (10400)
   * - ProfileOutOfSync (70411)
   * - MissingProfileProfileLock (70412): missing admin profile lock (for admin-profile-enabled orgs)
   * - AuthenticatorNotFound (40400): additional authenticator lock provided
   * - MissingProfileAuthenticatorLock (70410)
   * - VaultOutOfSync (50100)
   * - VaultNotFound (50400)
   * - MissingVault (50420): Missing personal vault data
   * - MissingVaultProfileLock (50411): missing personal vault lock or admin vault lock
   * - LicenseCountExceeded (60480): delegated admin count limit reached
   * - Internal (10500): Internal server error
   *
   * @generated from rpc domain.ChildOrganizationService.AddDelegatedAdmin
   */
  addDelegatedAdmin: {
    methodKind: "unary";
    input: typeof AddDelegatedAdminRequestSchema;
    output: typeof AddDelegatedAdminResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - ProfileNotFound (70400)
   * - OrganizationNotFound (60400): not member of the parent or child organization or organization is no child organization
   * - OrganizationInsufficientAccess (60100): not admin of parent org
   * - NotAllowedForOrganization (60101): organization has no parent organization
   * - OrganizationMissingAdmin (60410): after the call there would be no admin left or no delegated admin and no profile profile lock
   * - NotAllowedForProfile (70433): profile is no delegated admin
   * - Internal (10500): Internal server error
   *
   * @generated from rpc domain.ChildOrganizationService.RemoveDelegatedAdmin
   */
  removeDelegatedAdmin: {
    methodKind: "unary";
    input: typeof RemoveDelegatedAdminRequestSchema;
    output: typeof RemoveDelegatedAdminResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): not logged in
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - OrganizationNotFound (60400): not member of the parent or child organization or organization is no child organization
   * - OrganizationInsufficientAccess (60100): not delegated admin of the given organzation
   * - InvalidLicense (60481)
   * - Internal (10500)
   *
   * @generated from rpc domain.ChildOrganizationService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateChildOrganizationRequestSchema;
    output: typeof UpdateChildOrganizationResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400): not member of the parent or child organization or organization is no child organization
   * - OrganizationInsufficientAccess (60100): no admin in parent organization
   * - NotAllowedForOrganization (60101): organization still has a delegated admin
   * - Internal (10500): Internal server error
   *
   * @generated from rpc domain.ChildOrganizationService.ConvertToIndependent
   */
  convertToIndependent: {
    methodKind: "unary";
    input: typeof ConvertChildOrganizationToIndependentRequestSchema;
    output: typeof ConvertChildOrganizationToIndependentResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400): not member of the organization or target parent organization
   * - OrganizationInsufficientAccess (60100): no admin in organization
   * - NotAllowedForOrganization (60101): organization already has parent organization
   * - InvalidLicense (60481): organization has a license set
   * - Internal (10500): Internal server error 
   *
   * @generated from rpc domain.ChildOrganizationService.Adopt
   */
  adopt: {
    methodKind: "unary";
    input: typeof AdoptChildOrganizationRequestSchema;
    output: typeof AdoptChildOrganizationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_child_organization_service, 0);

